import axios from './api';

import { getToken, isSimulatedAuthenticationEnabled } from './enviroment';

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error?.response?.status === 401) {
      sessionStorage.clear();
      window.location.assign('/');
    }
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  async config => {
    const storedToken = getToken();
    const token = storedToken ? JSON.parse(storedToken) : null;

    if (
      token?.is_simulated_authentication &&
      isSimulatedAuthenticationEnabled()
    ) {
      config.headers['X-PagueFacil-Simulated-Auth'] = token.access_token;
    } else if (token && !token.is_simulated_authentication) {
      config.headers.Authorization = `Bearer ${token.access_token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
